/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Permit } from '../../../accessibility/permits';

export const AUTH_API_URLS_PREFIX = '/authentication';

export interface InspectorLoginParams {
    username: string;
    password: string;
    rememberMe?: boolean;
}

export interface InspectorLoginFormData extends InspectorLoginParams {
    token?: string;
}

export interface OperatorTaxpayerLoginFormData {
    personalID: string;
    phoneNumber: string;
}

export interface LoginResponseData {
    permits: Permit[];
    userId: number;
    firstName: string;
    middleName: string;
    lastName: string;
    email?: string;
    phone?: string;
    companyTaxNumber?: string;
}
